import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import styled from "@emotion/styled";
import { css } from "@emotion/styled";

import { theme } from "../../utils/global-styles/theme";

import DashboardDropdown from "./Dropdowns/DashboardDropdown";
import CollapseIcon from "../CollapseIcon/CollapseIcon";
import { currentLocation } from "../../utils/services/methods";

const DropdownLink = ({ title, url, dashboardDropdownLinks, locale }) => {
  const MyDashboardLinkContainer = styled.div`
      padding-top: 25px;
      margin-left: 3em;

      @media only screen and (max-width: ${theme.breakpoints.helper1100}) {
        display: none;
      }

      :hover .dashboard-dropdown-content {
        display: flex;
        padding: 10px;
      }
    `,
    LinkLabel = styled(Link)`
      color: ${theme.colors.black};
      font-weight: normal;
      
    `,
    Wrapper = styled.div`
      display: flex;
      align-items: flex-end;

      @media only screen and (min-width: ${theme.breakpoints.desktopUp}) {
        align-items: baseline;
      }
    `;
  return (
    <MyDashboardLinkContainer
      className={`${
        currentLocation()?.includes("/dashboard") ? "primary-link-container" : ""
      }`}
    >
      <Wrapper>
        <LinkLabel to={`${url}/`}>{title}</LinkLabel>
        <CollapseIcon />
      </Wrapper>
      <DashboardDropdown dropdownLinks={dashboardDropdownLinks} locale={locale} />
    </MyDashboardLinkContainer>
  );
};

DropdownLink.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  dashboardDropDownLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

export default DropdownLink;
